import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/infrastructure/service/api.service';

export interface PublicEmailPreferences {
  token: string;
  userName?: string;
  email?: string;
  tenantName?: string;
  mailSettings: string;
  commercialMailEnabled: boolean;
}

export interface PublicEmailPreferencesUpdateRequest {
  mailSettings: string;
  commercialMailEnabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class EmailPreferencesService extends ApiService {

  private serviceUrl = 'public/email-preferences';

  getByToken(token: string): Promise<PublicEmailPreferences> {
    return this.get(`${this.serviceUrl}/${token}`).toPromise();
  }

  updateByToken(token: string, request: PublicEmailPreferencesUpdateRequest): Promise<void> {
    return this.patch(`${this.serviceUrl}/${token}`, request).toPromise();
  }
}
